var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("summary-section-layout", {
    attrs: {
      id: "applicants",
      "section-title": _vm.$t("application-standalone.labels.applicants"),
      "has-missing-information": _vm.hasMissingInformation,
      "show-all-applicants": !_vm.IS_FILL_OUT,
    },
    on: {
      edit: function ($event) {
        return _vm.$emit("edit")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var applicant = ref.applicant
          return [
            _c(
              "p",
              {
                class: { "text-light-gray": !_vm.getApplicantEmail(applicant) },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.getApplicantEmail(applicant) ||
                        _vm.$t(
                          "application-standalone.pages.submit.pleaseAddEmail"
                        )
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }